
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/classrooms/lesson-library/u/register",
      function () {
        return require("private-next-pages/classrooms/lesson-library/u/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/classrooms/lesson-library/u/register"])
      });
    }
  